<div class="flex flex-col items-center inter-300">
  <!-- Help text -->
  <span class="text-sm text-support-text">
    Showing <span class="inter-500">{{ startIndex() }}</span> to <span class="inter-500">{{ endIndex() }}</span> of <span class="inter-500">{{ totalRecords }}</span>
  </span>
  <!-- Buttons -->
  <div class="inline-flex gap-3 mt-2">
    <button [disabled]="pageNumber === 1" (click)="previousPage()"
      class="px-4 py-2 rounded-full border border-nav-btn-border bg-transparent text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text inter-500 text-sm transition-colors disabled:opacity-50 disabled:pointer-events-none">
      Prev
    </button>
    <button [disabled]="endIndex() >= totalRecords" (click)="nextPage()"
      class="px-4 py-2 rounded-full border border-nav-btn-border bg-transparent text-nav-btn-text hover:bg-nav-btn-hover-bg hover:text-nav-btn-hover-text inter-500 text-sm transition-colors disabled:opacity-50 disabled:pointer-events-none">
      Next
    </button>
  </div>
</div>
